import { LocalIcon } from '~/shared/ui'
import type { CarcRarcGroup } from '../types'

interface TaggingHeaderProps {
  groups: CarcRarcGroup[]
  prefix: string
  onClearAll: () => void
}

export function TaggingHeader({ groups, prefix, onClearAll }: TaggingHeaderProps) {
  const selectedGroups = groups.filter((g) => g.carc_code)

  return (
    <div className="flex items-start justify-between">
      <div className="inline-flex flex-col items-start justify-start gap-1">
        {selectedGroups.map((group) => (
          <div
            key={group.id}
            className="inline-flex items-start justify-start gap-2"
          >
            <div className="flex items-center justify-start gap-2">
              <div className="flex items-center justify-start gap-0.5">
                <LocalIcon
                  name="orderOutlined"
                  size="18"
                  className="text-content-high-emphasis"
                />
                <span className="text-[15px] leading-5 tracking-[0.25px] text-[rgba(25,28,29,0.60)]">
                  CARC
                </span>
              </div>
              <span className="inline-block size-1 rounded-full bg-[rgba(25,28,29,0.54)]" />
              <span className="text-[15px] leading-5 tracking-[0.25px] text-[rgba(25,28,29,0.87)]">
                {prefix}
                {group.carc_code}
              </span>
            </div>
            {group.rarc_code && (
              <div className="flex items-center justify-start gap-2">
                <div className="flex items-center justify-start gap-0.5">
                  <LocalIcon
                    name="orderOutlined"
                    size="18"
                    className="text-content-high-emphasis"
                  />
                  <span className="text-[15px] leading-5 tracking-[0.25px] text-[rgba(25,28,29,0.60)]">
                    RARC
                  </span>
                </div>
                <span className="inline-block size-1 rounded-full bg-[rgba(25,28,29,0.54)]" />
                <span className="text-[15px] leading-5 tracking-[0.25px] text-[rgba(25,28,29,0.87)]">
                  {group.rarc_code}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
      {selectedGroups.length > 0 && (
        <button
          type="button"
          className="inline-flex cursor-pointer items-center gap-2 overflow-hidden rounded border-none bg-transparent px-2 py-1.5"
          onClick={onClearAll}
        >
          <span className="text-sm leading-6 font-medium tracking-[1.25px] text-[#0081BD] uppercase">
            clear all
          </span>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.475 15.3281C5.1 15.3281 4.78125 15.1969 4.51875 14.9344C4.25625 14.6719 4.125 14.3531 4.125 13.9781V4.45312H3.9375C3.775 4.45312 3.64075 4.39988 3.53475 4.29338C3.42825 4.18738 3.375 4.05313 3.375 3.89062C3.375 3.72812 3.42825 3.59387 3.53475 3.48787C3.64075 3.38137 3.775 3.32812 3.9375 3.32812H6.75C6.75 3.14062 6.8155 2.98438 6.9465 2.85938C7.078 2.73437 7.2375 2.67188 7.425 2.67188H10.575C10.7625 2.67188 10.922 2.73437 11.0535 2.85938C11.1845 2.98438 11.25 3.14062 11.25 3.32812H14.0625C14.225 3.32812 14.3595 3.38137 14.466 3.48787C14.572 3.59387 14.625 3.72812 14.625 3.89062C14.625 4.05313 14.572 4.18738 14.466 4.29338C14.3595 4.39988 14.225 4.45312 14.0625 4.45312H13.875V13.9781C13.875 14.3531 13.7438 14.6719 13.4813 14.9344C13.2188 15.1969 12.9 15.3281 12.525 15.3281H5.475ZM5.25 4.45312V13.9781C5.25 14.0406 5.272 14.0939 5.316 14.1379C5.3595 14.1814 5.4125 14.2031 5.475 14.2031H12.525C12.5875 14.2031 12.6408 14.1814 12.6848 14.1379C12.7283 14.0939 12.75 14.0406 12.75 13.9781V4.45312H5.25ZM7.05 12.1406C7.05 12.3031 7.10325 12.4376 7.20975 12.5441C7.31575 12.6501 7.45 12.7031 7.6125 12.7031C7.775 12.7031 7.9095 12.6501 8.016 12.5441C8.122 12.4376 8.175 12.3031 8.175 12.1406V6.51562C8.175 6.35312 8.122 6.21862 8.016 6.11212C7.9095 6.00612 7.775 5.95312 7.6125 5.95312C7.45 5.95312 7.31575 6.00612 7.20975 6.11212C7.10325 6.21862 7.05 6.35312 7.05 6.51562V12.1406ZM9.825 12.1406C9.825 12.3031 9.878 12.4376 9.984 12.5441C10.0905 12.6501 10.225 12.7031 10.3875 12.7031C10.55 12.7031 10.6845 12.6501 10.791 12.5441C10.897 12.4376 10.95 12.3031 10.95 12.1406V6.51562C10.95 6.35312 10.897 6.21862 10.791 6.11212C10.6845 6.00612 10.55 5.95312 10.3875 5.95312C10.225 5.95312 10.0905 6.00612 9.984 6.11212C9.878 6.21862 9.825 6.35312 9.825 6.51562V12.1406Z"
              fill="#0081BD"
            />
          </svg>
        </button>
      )}
    </div>
  )
}
